import "babel-polyfill";
import React, { Component } from 'react';
import Route from './modules/router/Route'
import './styles/index.css'

import DataLoader from './modules/data/DataLoader'

import HomePage from './modules/HomePage'
import Header from './modules/header/Header'
import Footer from './modules/footer/Footer'
import PageAccordion from './modules/pageAccordion/PageAccordion'

import LanguageChecker from './modules/multilang/LanguageChecker'

import Router from './modules/router/Router'

import { Provider } from 'react-redux'
import { createStore } from 'redux'

import reducer from './reducers/index'

import FullBrowserHeightFix from './modules/misc/FullBrowserHeightFix'

import TransitionScreens from './modules/transitionscreens/TransitionScreens'


let store =  createStore(reducer)

class App extends Component {


   constructor(props){

      super();

      this.state = {
          showHeader:true,
          showSpacer:true,
          delayFadeIn:false,
          showHomepage:undefined,
          screenHeight: window.innerHeight
      }

      this.onScroll = this.onScroll.bind(this);

      this.resetHomePage = this.resetHomePage.bind(this);
      this.hidingHomepage = this.hidingHomepage.bind(this);

   }


   onScroll(){


      let headerHeight = 92;

      // Disable if not on the HomePage

      /*
      if(window.location.pathname ==='/'){
          if(window.scrollY<(window.innerHeight-headerHeight) && this.state.showHeader){
            //console.log('show header false');
            //this.setState({showHeader:false})
          }

          if(window.scrollY>(window.innerHeight*.8) && !this.state.showHeader){
            console.log('show header true');
            this.setState({showHeader:true})
          }

      }else if(!this.state.showHeader){
        this.setState({showHeader:true})
      }
      */

      // move down the accordian pages if on home page
      //if(window.location.pathname !=='/about/'){
      if(window.location.pathname !=='/' && window.location.pathname !=='/about/'){
          /*
          if(window.scrollY<20){
              this.setState({showSpacer:true})
          }else{
              this.setState({showSpacer:false})
          }*/

      }else{
        (this.state.showSpacer!==false)?
          this.setState({showSpacer:false})
        : null ;
      }


      //window.requestAnimationFrame(this.onScroll);

   }

   componentDidMount(){
    // window.addEventListener('scroll',this.onScroll)
     //this.onScroll();
     //window.requestAnimationFrame(this.onScroll)
     if(window.location.pathname.length > 2){
       this.setState({delayFadeIn:true})
     }
   }


   getMobileOperatingSystem() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;

          // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return "windows-phone";
        }

        if (/android/i.test(userAgent)) {
            return "android";
        }

        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "ios";
        }

        return "desktop-os";
    }

   resetHomePage(){
     console.log("Reset Homepage");
     this.setState({showHomepage:true})
   }

   hidingHomepage(){
     this.setState({showHomepage:undefined})
   }



  render() {


    let spacerClass = 'show'; // (this.state.showSpacer)? 'show' : 'hide'


    let forceShowHeaderClass = ''//(this.state.showSpacer)? ' force-show-header ' : '' ;

    let forceHideHeaderClass = (!this.state.showHeader)? ' force-hide-header' : '' ;

    /// overide to show header if the page is scrolled right up

    let osClass = this.getMobileOperatingSystem()


    return (
      <Provider store={store}>
        <div className={osClass}>
        <div className="scroll-container">

        <LanguageChecker />
        <DataLoader>
        <div className={this.state.delayFadeIn? " delay-site-fadein" : " "} >
        <div className={(forceShowHeaderClass)+(forceHideHeaderClass)}>
          <Header showHeader={this.state.showHeader} resetHomePage={this.resetHomePage} ></Header>
        </div>
            <div id="pageWrapper" >

              <Route path='/' exact >
                <HomePage resetPage={this.state.showHomepage} hidingHomepage={this.hidingHomepage} />
              </Route>

              <div className={'head-spacer '+(spacerClass)} />
              <PageAccordion />
            </div>

          <Footer />

          <TransitionScreens />


      </div>
      </DataLoader>

      <FullBrowserHeightFix />
      <Router />
      </div>
    </div>
    </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js